import { createContext, useContext } from "react";

export const ManageContext = createContext({
  manage: false,
});

export const useManage = () => {
  const context = useContext(ManageContext);
  if (!context) {
    throw new Error("useManage must be used within a ManageProvider");
  }
  return context.manage;
};

// Read-only is set by the admin app (details-page preview) when the account's trial/subscription
// has lapsed. Public/embed contexts never set it, so it defaults to false there.
export const useReadOnly = () => {
  const context = useContext(ManageContext);
  return !!context?.readOnly;
};
